export default "__VITE_ASSET__BG6Qdwef__"